export const state = () => ({
  rolePermissions: [],
  loading: false,
  error: null,
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0
  }
})

export const getters = {
  rolePermissions: (state) => state.rolePermissions,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_ROLE_PERMISSIONS(state, data) {
    if (data.content) {
      state.rolePermissions = data.content
      state.pagination = {
        page: data.number,
        size: data.size,
        totalElements: data.totalElements,
        totalPages: data.totalPages
      }
    } else {
      state.rolePermissions = Array.isArray(data) ? data : []
    }
  },
  ADD_ROLE_PERMISSION(state, rolePermission) {
    state.rolePermissions.push(rolePermission)
  },
  REMOVE_ROLE_PERMISSION(state, { roleId, permissionId }) {
    state.rolePermissions = state.rolePermissions.filter(
      rp => !(rp.role?.id === roleId && rp.permission?.id === permissionId)
    )
  }
}

export const actions = {
  async fetchRolePermissions({ commit }, { roleId, page = 0, size = 10, sortBy = 'permissionId', direction = 'asc' } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/role-permissions/by-role/${roleId}`, {
        params: { page, size, sortBy, direction }
      })
      commit('SET_ROLE_PERMISSIONS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch role permissions')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async assignPermission({ commit }, rolePermissionData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post('/auth/api/role-permissions', rolePermissionData)
      commit('ADD_ROLE_PERMISSION', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to assign permission')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async removePermission({ commit }, { roleId, permissionId }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this.$axios.delete('/auth/api/role-permissions', {
        data: { roleId, permissionId }
      })
      commit('REMOVE_ROLE_PERMISSION', { roleId, permissionId })
      return true
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to remove permission')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

